"use client";

import { useState } from 'react';

export default function InsuranceDashboardsSection() {
  const [activeTab, setActiveTab] = useState(0);

  const dashboards = [
    {
      title: 'EXECUTIVE INSURANCE DASHBOARD',
      subtitle: 'Insurance Executive Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Insurance Executive Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {/* KPI Cards */}
          {[
            { x: 16, label: 'Total Premium Revenue', value: '₹2,847Cr', sub: '+6.4% YoY', color: '#1B2845' },
            { x: 186, label: 'Loss Ratio', value: '62.4%', sub: 'Target: <65%', color: '#16a34a' },
            { x: 356, label: 'Customer Retention', value: '87%', sub: '+2.1% vs LY', color: '#C5A572' },
            { x: 526, label: 'Combined Ratio', value: '94.2%', sub: 'Industry: 97.8%', color: '#1B2845' },
          ]?.map((kpi, i) => (
            <g key={i}>
              <rect x={kpi?.x} y="56" width="158" height="68" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi?.x + 12} y="76" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi?.label}</text>
              <text x={kpi?.x + 12} y="96" fill={kpi?.color} fontSize="16" fontWeight="bold" fontFamily="sans-serif">{kpi?.value}</text>
              <text x={kpi?.x + 12} y="114" fill="#9ca3af" fontSize="9" fontFamily="sans-serif">{kpi?.sub}</text>
            </g>
          ))}

          {/* Premium Revenue Trend */}
          <rect x="16" y="136" width="420" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Premium Revenue Trend (₹Cr)</text>
          <polyline points="40,290 100,275 160,268 220,255 280,260 340,242 400,235 420,228" fill="none" stroke="#1B2845" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          <polyline points="40,290 100,275 160,268 220,255 280,260 340,242 400,235 420,228 420,310 40,310 Z" fill="#1B2845" opacity="0.05" />
          {[40,100,160,220,280,340,400,420]?.map((x, i) => (
            <circle key={i} cx={x} cy={[290,275,268,255,260,242,235,228]?.[i]} r="3" fill="#C5A572" />
          ))}
          {['Q1','Q2','Q3','Q4','Q1','Q2','Q3','Q4']?.map((q, i) => (
            <text key={i} x={[40,100,160,220,280,340,400,420]?.[i] - 6} y="308" fill="#9ca3af" fontSize="8" fontFamily="sans-serif">{q}</text>
          ))}

          {/* Policy Growth by Segment Donut */}
          <rect x="448" y="136" width="236" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="460" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Policy Growth by Segment</text>
          <circle cx="530" cy="230" r="45" fill="none" stroke="#1B2845" strokeWidth="18" strokeDasharray="113 170" strokeDashoffset="0" />
          <circle cx="530" cy="230" r="45" fill="none" stroke="#C5A572" strokeWidth="18" strokeDasharray="68 215" strokeDashoffset="-113" />
          <circle cx="530" cy="230" r="45" fill="none" stroke="#3b82f6" strokeWidth="18" strokeDasharray="57 226" strokeDashoffset="-181" />
          <circle cx="530" cy="230" r="45" fill="none" stroke="#10b981" strokeWidth="18" strokeDasharray="45 238" strokeDashoffset="-238" />
          <text x="530" y="226" textAnchor="middle" fill="#1B2845" fontSize="12" fontWeight="bold" fontFamily="sans-serif">Policy</text>
          <text x="530" y="240" textAnchor="middle" fill="#6b7280" fontSize="8" fontFamily="sans-serif">Mix</text>
          {[
            { color: '#1B2845', label: 'Life', pct: '40%' },
            { color: '#C5A572', label: 'Health', pct: '24%' },
            { color: '#3b82f6', label: 'Motor', pct: '20%' },
            { color: '#10b981', label: 'Property', pct: '16%' },
          ]?.map((item, i) => (
            <g key={i}>
              <rect x="590" y={163 + i * 22} width="10" height="10" rx="2" fill={item?.color} />
              <text x="604" y={173 + i * 22} fill="#374151" fontSize="9" fontFamily="sans-serif">{item?.label}: {item?.pct}</text>
            </g>
          ))}

          {/* Loss Ratio by Product */}
          <rect x="16" y="328" width="668" height="80" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="346" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Loss Ratio by Product Line</text>
          {[
            { label: 'Life Insurance', val: 58, color: '#16a34a' },
            { label: 'Health Insurance', val: 72, color: '#d97706' },
            { label: 'Motor Insurance', val: 65, color: '#C5A572' },
            { label: 'Property Insurance', val: 48, color: '#1B2845' },
          ]?.map((bar, i) => (
            <g key={i}>
              <text x={28 + i * 165} y="362" fill="#6b7280" fontSize="8" fontFamily="sans-serif">{bar?.label}</text>
              <rect x={28 + i * 165} y="366" width={bar?.val * 1.5} height="12" fill={bar?.color} rx="2" opacity="0.8" />
              <text x={34 + i * 165} y="376" fill="white" fontSize="8" fontWeight="bold" fontFamily="sans-serif">{bar?.val}%</text>
            </g>
          ))}
        </svg>
      ),
    },
    {
      title: 'UNDERWRITING & RISK DASHBOARD',
      subtitle: 'Risk Exposure & Underwriting Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Underwriting & Risk Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {/* KPI Cards */}
          {[
            { x: 16, label: 'Underwriting Accuracy', value: '91%', sub: '+3.2% vs LY', color: '#16a34a' },
            { x: 186, label: 'Risk Exposure', value: '₹8,420Cr', sub: 'Within limits', color: '#C5A572' },
            { x: 356, label: 'Avg Loss Ratio', value: '62.4%', sub: 'Target: <65%', color: '#1B2845' },
            { x: 526, label: 'High Risk Policies', value: '2.8%', sub: '↓ 0.4% MoM', color: '#16a34a' },
          ]?.map((kpi, i) => (
            <g key={i}>
              <rect x={kpi?.x} y="56" width="158" height="68" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi?.x + 12} y="76" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi?.label}</text>
              <text x={kpi?.x + 12} y="96" fill={kpi?.color} fontSize="18" fontWeight="bold" fontFamily="sans-serif">{kpi?.value}</text>
              <text x={kpi?.x + 12} y="114" fill="#9ca3af" fontSize="9" fontFamily="sans-serif">{kpi?.sub}</text>
            </g>
          ))}

          {/* Risk Distribution Donut */}
          <rect x="16" y="136" width="220" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Policy Risk Distribution</text>
          <circle cx="116" cy="230" r="50" fill="none" stroke="#16a34a" strokeWidth="20" strokeDasharray="188 126" strokeDashoffset="0" />
          <circle cx="116" cy="230" r="50" fill="none" stroke="#d97706" strokeWidth="20" strokeDasharray="75 239" strokeDashoffset="-188" />
          <circle cx="116" cy="230" r="50" fill="none" stroke="#dc2626" strokeWidth="20" strokeDasharray="51 263" strokeDashoffset="-263" />
          <text x="116" y="226" textAnchor="middle" fill="#1B2845" fontSize="12" fontWeight="bold" fontFamily="sans-serif">Risk</text>
          <text x="116" y="240" textAnchor="middle" fill="#6b7280" fontSize="9" fontFamily="sans-serif">Profile</text>
          {[
            { color: '#16a34a', label: 'Low Risk', pct: '60%' },
            { color: '#d97706', label: 'Medium', pct: '24%' },
            { color: '#dc2626', label: 'High Risk', pct: '16%' },
          ]?.map((item, i) => (
            <g key={i}>
              <rect x="28" y={290 + i * 16} width="8" height="8" rx="1" fill={item?.color} />
              <text x="40" y={298 + i * 16} fill="#374151" fontSize="9" fontFamily="sans-serif">{item?.label}: {item?.pct}</text>
            </g>
          ))}

          {/* Risk Exposure by Region */}
          <rect x="248" y="136" width="436" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="260" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Risk Exposure by Region (₹Cr)</text>
          {[
            { region: 'Maharashtra', exposure: 2840, color: '#1B2845' },
            { region: 'Delhi NCR', exposure: 2100, color: '#C5A572' },
            { region: 'Karnataka', exposure: 1650, color: '#3b82f6' },
            { region: 'Tamil Nadu', exposure: 1200, color: '#8b5cf6' },
            { region: 'Gujarat', exposure: 980, color: '#10b981' },
          ]?.map((item, i) => {
            const maxVal = 2840;
            const barW = (item?.exposure / maxVal) * 280;
            return (
              <g key={i}>
                <text x="260" y={178 + i * 26} fill="#6b7280" fontSize="9" fontFamily="sans-serif">{item?.region}</text>
                <rect x="360" y={166 + i * 26} width={barW} height="14" fill={item?.color} rx="2" opacity="0.8" />
                <text x={366 + barW} y={178 + i * 26} fill="#374151" fontSize="9" fontFamily="sans-serif">₹{item?.exposure}Cr</text>
              </g>
            );
          })}

          {/* Underwriting Performance */}
          <rect x="16" y="328" width="668" height="80" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="346" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Underwriting Decision Accuracy by Product</text>
          {[
            { product: 'Life', accuracy: 94, color: '#16a34a' },
            { product: 'Health', accuracy: 88, color: '#C5A572' },
            { product: 'Motor', accuracy: 91, color: '#1B2845' },
            { product: 'Property', accuracy: 86, color: '#3b82f6' },
            { product: 'Marine', accuracy: 79, color: '#8b5cf6' },
          ]?.map((item, i) => (
            <g key={i}>
              <text x={28 + i * 130} y="362" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{item?.product}</text>
              <rect x={28 + i * 130} y="366" width={item?.accuracy * 1.1} height="12" fill={item?.color} rx="2" opacity="0.8" />
              <text x={34 + i * 130} y="376" fill="white" fontSize="8" fontWeight="bold" fontFamily="sans-serif">{item?.accuracy}%</text>
            </g>
          ))}
        </svg>
      ),
    },
    {
      title: 'CLAIMS ANALYTICS DASHBOARD',
      subtitle: 'Claims & Fraud Detection Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Claims Analytics Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {/* KPI Cards */}
          {[
            { x: 16, label: 'Avg Settlement Time', value: '14.2 days', sub: '↓ 3.1 days MoM', color: '#16a34a' },
            { x: 186, label: 'Claims This Month', value: '4,821', sub: '+2.4% vs LY', color: '#1B2845' },
            { x: 356, label: 'Fraud Alerts', value: '38', sub: '12 high severity', color: '#dc2626' },
            { x: 526, label: 'Claims Cost', value: '₹284Cr', sub: 'Within budget', color: '#C5A572' },
          ]?.map((kpi, i) => (
            <g key={i}>
              <rect x={kpi?.x} y="56" width="158" height="68" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi?.x + 12} y="76" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi?.label}</text>
              <text x={kpi?.x + 12} y="96" fill={kpi?.color} fontSize="16" fontWeight="bold" fontFamily="sans-serif">{kpi?.value}</text>
              <text x={kpi?.x + 12} y="114" fill="#9ca3af" fontSize="9" fontFamily="sans-serif">{kpi?.sub}</text>
            </g>
          ))}

          {/* Claims Frequency Trend */}
          <rect x="16" y="136" width="330" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Claims Frequency Trend</text>
          <polyline points="30,290 80,275 130,280 180,265 230,270 280,255 320,248" fill="none" stroke="#1B2845" strokeWidth="2" strokeLinecap="round" />
          <polyline points="30,290 80,275 130,280 180,265 230,270 280,255 320,248 320,310 30,310 Z" fill="#1B2845" opacity="0.04" />
          {['Jan','Feb','Mar','Apr','May','Jun','Jul']?.map((m, i) => (
            <text key={i} x={30 + i * 48} y="308" fill="#9ca3af" fontSize="8" fontFamily="sans-serif">{m}</text>
          ))}

          {/* Fraud Detection Alerts */}
          <rect x="358" y="136" width="326" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="370" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Fraud Detection Alerts</text>
          {[
            { claim: 'Claim #48291 — Motor', severity: 'HIGH', color: '#dc2626', bg: '#fef2f2', amount: '₹4.2L' },
            { claim: 'Claim #48156 — Health', severity: 'HIGH', color: '#dc2626', bg: '#fef2f2', amount: '₹2.8L' },
            { claim: 'Claim #47982 — Property', severity: 'MED', color: '#d97706', bg: '#fffbeb', amount: '₹1.5L' },
            { claim: 'Claim #47841 — Life', severity: 'MED', color: '#d97706', bg: '#fffbeb', amount: '₹8.4L' },
            { claim: 'Claim #47620 — Motor', severity: 'LOW', color: '#16a34a', bg: '#f0fdf4', amount: '₹0.6L' },
          ]?.map((alert, i) => (
            <g key={i}>
              <rect x="370" y={163 + i * 28} width="302" height="22" rx="4" fill={alert?.bg} />
              <text x="380" y={178 + i * 28} fill="#374151" fontSize="9" fontFamily="sans-serif">{alert?.claim}</text>
              <text x="560" y={178 + i * 28} fill="#6b7280" fontSize="9" fontFamily="sans-serif">{alert?.amount}</text>
              <rect x="628" y={165 + i * 28} width="32" height="18" rx="3" fill={alert?.color} opacity="0.15" />
              <text x="644" y={178 + i * 28} textAnchor="middle" fill={alert?.color} fontSize="8" fontWeight="bold" fontFamily="sans-serif">{alert?.severity}</text>
            </g>
          ))}

          {/* Claims Cost by Category */}
          <rect x="16" y="328" width="668" height="80" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="346" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Claims Cost Analysis by Category (₹Cr)</text>
          {[
            { label: 'Health', val: 110, color: '#C5A572' },
            { label: 'Motor', val: 85, color: '#1B2845' },
            { label: 'Life', val: 60, color: '#3b82f6' },
            { label: 'Property', val: 29, color: '#10b981' },
          ]?.map((bar, i) => (
            <g key={i}>
              <text x={28 + i * 165} y="362" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{bar?.label}</text>
              <rect x={28 + i * 165} y="366" width={bar?.val * 1.5} height="12" fill={bar?.color} rx="2" opacity="0.8" />
              <text x={34 + i * 165} y="376" fill="white" fontSize="8" fontWeight="bold" fontFamily="sans-serif">₹{bar?.val}Cr</text>
            </g>
          ))}
        </svg>
      ),
    },
  ];

  return (
    <section className="py-24 bg-cream px-4 sm:px-6 lg:px-8 xl:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-serif text-navy text-2xl sm:text-3xl md:text-4xl xl:text-[3rem] leading-[1.2] font-bold mb-4">
            Role-Specific Intelligence for <span className="italic">Insurance Leaders</span>
          </h2>
          <p className="text-charcoal/70 text-lg max-w-2xl mx-auto">Real-time dashboards built for every decision-maker in your insurance organization.</p>
        </div>

        {/* Tab Navigation */}
        <div className="flex flex-wrap gap-3 justify-center mb-10">
          {dashboards?.map((dashboard, index) => (
            <button
              key={index}
              onClick={() => setActiveTab(index)}
              className={`px-6 py-3 rounded-lg font-semibold text-sm transition-all duration-300 ${
                activeTab === index
                  ? 'bg-navy text-white shadow-lg'
                  : 'bg-white text-navy border border-gray-200 hover:border-gold/40 hover:shadow-md'
              }`}
            >
              {dashboard?.title}
            </button>
          ))}
        </div>

        {/* Dashboard Display */}
        <div className="bg-white rounded-2xl p-6 md:p-8 border border-gray-200 shadow-lg">
          <div className="mb-4">
            <h3 className="font-serif text-navy text-xl font-bold">{dashboards?.[activeTab]?.title}</h3>
            <p className="text-charcoal/60 text-sm">{dashboards?.[activeTab]?.subtitle}</p>
          </div>
          <div className="w-full aspect-[700/420] rounded-xl overflow-hidden border border-gray-100">
            {dashboards?.[activeTab]?.svg}
          </div>
        </div>
      </div>
    </section>
  );
}
